import { c as _c } from "react/compiler-runtime";
import { Stack, type SxProps, type Theme } from '@mui/material';
import type { ReactNode } from 'react';
import { EmptyStateContent } from './emptyStateContent';
export const PanelEmptyState = t0 => {
  const $ = _c(16);
  const {
    title,
    description,
    icon,
    primaryAction,
    secondaryAction,
    minHeight: t1,
    sx
  } = t0;
  const minHeight = t1 === undefined ? "160px" : t1;
  let t2;
  if ($[0] !== minHeight) {
    t2 = {
      alignItems: "center",
      justifyContent: "center",
      minHeight,
      padding: "24px"
    };
    $[0] = minHeight;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== sx) {
    t3 = sx ? Array.isArray(sx) ? sx : [sx] : [];
    $[2] = sx;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = [t2, ...t3];
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== description || $[8] !== icon || $[9] !== primaryAction || $[10] !== secondaryAction || $[11] !== title) {
    t5 = <EmptyStateContent title={title} description={description} icon={icon} primaryAction={primaryAction} secondaryAction={secondaryAction} titleVariant="h4" descriptionVariant="body2" gap="12px" textGap="8px" maxWidth="440px" />;
    $[7] = description;
    $[8] = icon;
    $[9] = primaryAction;
    $[10] = secondaryAction;
    $[11] = title;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <Stack sx={t4}>{t5}</Stack>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};